import ArticleResourceModel from '../../generated/types/model/resource/ArticleResourceModel';

export default class ArticleResourceViewModel extends ArticleResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
